import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, with later Tailwind utilities beating earlier ones.
 *
 * `clsx` alone would leave `px-2 px-4` both in the string and let CSS source
 * order decide - which means a variant cannot reliably override a base style.
 * twMerge resolves the conflict in favour of the last one, which is what every
 * caller expects when they pass a className prop.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
